import React from 'react';
import { BookOpenIcon, CheckIcon, GiftIcon, TrophyIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { PriceCta } from '../PriceCta';
import { offerChecks, valueStack } from '../../data/offer';
export function ValueStack() {
  const total = valueStack.reduce((sum, row) => sum + row.value, 0);
  return <section id="offer" aria-labelledby="value-stack" className="bg-paper px-4 py-16 sm:py-24" data-id="element-333" data-mp="1buzbq37t2whl">
      <div className="mx-auto max-w-2xl" data-id="element-334" data-mp="o4vau3m05aua">
        <div id="value-stack" data-id="element-335" data-mp="k3a2mvkexkqf">
          <SectionHeading kicker="Special introductory offer" title="Here’s everything you’ll receive today" data-id="element-336" data-mp="k41pnhzy2a53" />
        </div>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white shadow-[0_24px_60px_-20px_rgba(10,29,69,0.35)] ring-2 ring-cta" data-id="element-337" data-mp="xvpz1dit6kid">
          <div className="flex items-center justify-center gap-2 bg-navy-900 py-3 text-sm font-extrabold uppercase tracking-wider text-cta" data-id="element-338" data-mp="5e41h220lkfw">
            <TrophyIcon className="h-4 w-4" aria-hidden="true" data-id="element-339" data-mp="e9db69mj8yj" />
            Complete collection
          </div>

          <ul className="divide-y divide-ink/10 px-5 sm:px-8" data-id="element-340" data-mp="2jpiw2bvya7pk">
            {valueStack.map(row => {
            const Icon = row.main ? BookOpenIcon : GiftIcon;
            return <li key={row.label} className="flex items-start gap-3 py-4" data-id="element-341" data-mp="2tgdlfp4htnf8">
                  <Icon className={`mt-0.5 h-5 w-5 shrink-0 ${row.main ? 'text-navy-700' : 'text-alert'}`} aria-hidden="true" data-id="element-342" data-mp="2yf85eue75i0x" />
                  <span className={`flex-1 leading-snug ${row.main ? 'font-extrabold text-ink' : 'font-medium text-ink/85'}`} data-id="element-343" data-mp="20sr9ntl43cha">
                    {row.label}
                  </span>
                  <span className="shrink-0 font-semibold tabular-nums text-ink/50 line-through" data-id="element-344" data-mp="2aoksfupfc27i">${row.value}</span>
                </li>;
          })}
          </ul>

          <div className="mx-5 flex items-center justify-between border-t-2 border-dashed border-ink/15 py-4 sm:mx-8" data-id="element-345" data-mp="3m5apoobvdjoz">
            <span className="text-sm font-extrabold uppercase tracking-wide text-ink" data-id="element-346" data-mp="3q4talk3oxurt">Total illustrative value</span>
            <span className="font-display text-2xl font-black text-alert line-through" data-id="element-347" data-mp="1qzjivw4m97g9">${total} USD</span>
          </div>

          <div className="bg-cta/15 px-5 py-8 text-center sm:px-8" data-id="element-348" data-mp="1m4m92mziiu2b">
            <p className="text-lg font-semibold text-ink/80" data-id="element-349" data-mp="201j28v33snmd">Today, you can get the complete collection for just…</p>
            <p className="mt-2 font-display text-[5.5rem] font-black leading-none tracking-tight text-ink sm:text-8xl" data-id="element-350" data-mp="1v0v9a3vbdwpi">$27</p>
            <p className="mt-1 text-sm font-extrabold uppercase tracking-wider text-ok" data-id="element-351" data-mp="13c1xciby35lq">USD · One-time payment</p>
          </div>

          <div className="px-5 py-7 sm:px-8" data-id="element-352" data-mp="1h48d43b6rakn">
            <ul className="mb-7 grid gap-2.5 sm:grid-cols-2" data-id="element-353" data-mp="1h51c2i3wkvs8">
              {offerChecks.map(c => <li key={c} className="flex items-center gap-2.5 font-semibold text-ink" data-id="element-354" data-mp="1canbm1advygp">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ok text-white" data-id="element-355" data-mp="okt3ty4x903b">
                    <CheckIcon className="h-3.5 w-3.5" strokeWidth={3.5} aria-hidden="true" data-id="element-356" data-mp="2vb65mkdr8v8n" />
                  </span>
                  {c}
                </li>)}
            </ul>
            <PriceCta label="Yes! I want the complete roadmap for $27" note="One-time payment · Digital educational product" data-id="element-357" data-mp="2magbrm821exk" />
            <p className="mt-6 text-center leading-relaxed text-ink/70" data-id="element-358" data-mp="2r91a1g3qxojd">
              For one payment of $27, you’ll have a dedicated educational collection to revisit as you continue studying
              arterial blood gases.
            </p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink/50" data-id="element-359" data-mp="350y07elutod4">
          These figures are illustrative offer-positioning estimates, not independently verified retail prices.
        </p>
      </div>
    </section>;
}